import styled from 'styled-components';

import { colors, fontFamilySize, px } from '../../../../../../contrib/ui';

export const TeeBoxRowsStyled = styled.div`
  .flights-input.override {
    margin-top: 0;
  }

  .input-form-control {
    &.handicap,
    &.number {
      .input-label.override {
        &[data-shrink='false'] {
          top: ${px(-7)};
          left: 25%;
          font-size: ${px(9)};
        }
        &[data-shrink='true'] {
          display: none;
        }
      }
    }
  }

  .table-title.to-field {
    ${fontFamilySize('Bold', 16)}
    color: ${colors.dark};
  }

  .autocomplete {
    margin-top: 0 !important;
    .autocomplete__menu {
      padding: 0;
      .autocomplete__option {
        min-height: var(--smallButtonHeight);
      }
    }
  }
`;
